import React from 'react'

const Introduction = ({ description }) => {
    return (
        <React.Fragment>
            <div className="section-title-block">
                <h2 className="section-title">About Me</h2>
                <h5 className="section-description">
                    {description}
                </h5>
            </div>
            <div className="row">
                <div className="col-sm-12 col-md-12 subpage-block">
                    <div className="general-info">
                        <h3>Full Stack Engineer</h3>
                        <p>
                            A Full Stack Engineer, currently working to digitize the clinical trials process for Alzheimer’s treatment.
                            I am working in the healthcare sector for the past couple of years and before that,
                            I worked on the development of FinTech products.
                        </p>
                        <p>
                            I enjoy working on new ideas and challenging projects that aim to create a positive impact
                            in the lives of people. This motivates me to employ and improve my communication, technical
                            and analytical skills.
                        </p>
                        <p>
                            My expertise is in Full Stack Software Development from requirements analysis to production.
                            Throughout my career, I have used various tools and technologies depending on the requirements;
                            currently, I am working with the following technology stack:
                        </p>
                        <p><i> <u>Python, JavaScript, Django, React, AWS, PostgreSQL</u></i></p>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default Introduction